/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CANCEL: 'Ακύρωση',
    CONFIRM: 'Επιβεβαίωση',
    CONFIRM_POLL_RESPONSE: 'Επιβεβαίωση απάντησης',
    CONTINUE: 'Συνέχεια',
    COPY: 'Αντιγραφή',
    DELETE: 'Διαγραφή',
    DELETE_MESSAGE: 'Διαγραφή μηνύματος',
    EDIT: 'Επεξεργασία',
    FINISH: 'Ολοκλήρωση',
    HIDE_ANSWERS: 'Απόκρυψη απαντήσεων',
    LETS_GET_STARTED: 'Φυσικά, ας ξεκινήσουμε.',
    MARK_AS_UNREAD: 'Χαρακτηρίστε ως αδιάβαστο',
    REPLY: 'Απάντηση',
    SEE_ANSWERS: 'Δείτε τις απαντήσεις',
    START_SURVEY: 'Έναρξη έρευνας'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'Το μέγιστο μέγεθος αρχείου είναι {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Η έρευνα έληξε επειδή υπάρχει ήδη μια καμπάνια για αυτήν την κατηγορία.',
    ERROR_CREATING_NEW_SUGGESTION: 'Σφάλμα κατά τη δημιουργία νέας προσφοράς',
    ERROR_SAVING_PRODUCT_REVIEW:
      'Σφάλμα κατά την αποθήκευση της αξιολόγησης του προϊόντος',
    ERROR_SENDING_MESSAGE: 'Σφάλμα αποστολής μηνύματος',
    ERROR_SUBMITTING_SURVEY: 'Σφάλμα κατά την υποβολή της έρευνας',
    IMAGE_SIZE_EXCEEDED: 'Το μέγιστο μέγεθος μιας εικόνας είναι {size}MB',
    MESSAGE_ALREADY_READ:
      'Αυτό το μήνυμα δεν μπορεί πλέον να επεξεργαστεί επειδή έχει ήδη αναγνωστεί.',
    UPLOADED_ASSETS_EXCEED: 'Ο μέγιστος αριθμός αρχείων είναι {limit}',
    VIDEO_SIZE_EXCEEDED: 'Το μέγιστο μέγεθος ενός βίντεο είναι {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Δράσεις',
    ADDITIONAL_COMMENTS_QUESTION: 'Πρόσθετο σχόλιο;',
    ANSWERED_ON: 'Απαντήθηκε σε {date}',
    CONTACT_OWNER: 'Κάτι πήγε στραβά. Επικοινωνήστε με τον διευθυντή σας',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Κάντε κλικ εδώ για να δημιουργήσετε νέα προσφορά',
    EDITED: 'Επεξεργασία',
    EXPIRED_ON: 'Έληξε η {date}',
    LAST_READ: 'Τελευταία ανάγνωση',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Ληγμένη προσφορά',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Αποδεχόμενοι, η καμπάνια θα δημιουργηθεί και θα ξεκινήσει αύριο.\nΑύριο θα λάβετε επίσης το μήνυμα με την αφίσα για κοινοποίηση.\nΑυτή η προσφορά θα είναι διαθέσιμη για 3 ημέρες.',
    QUANTITY: 'Ποσότητα',
    REACT: 'Αντιδράστε',
    REACTIONS: 'Αντιδράσεις',
    RESPOND_BY: 'Απάντηση έως {date}',
    SEE_PRODUCTS: 'Δείτε προϊόντα',
    SEEN: 'Είδα',
    SELECT_ADDRESS: 'Επιλογή διεύθυνσης',
    SELECT_ONE_OPTION: 'Επιλέξτε μια επιλογή',
    SELECT_ONE_OR_MORE_OPTION: 'Επιλέξτε μία ή περισσότερες επιλογές',
    SENT: 'Αποστολή',
    SWIPE_TO_CANCEL: 'Σαρώστε για ακύρωση',
    TYPE_NEW_MESSAGE: 'Γράψτε ένα νέο μήνυμα',
    VOICE_MESSAGE: 'Φωνητικό μήνυμα'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Αυτή η ενέργεια θα επιβεβαιώσει την παραγγελία και δεν θα είναι δυνατή η αλλαγή της απάντησης. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
    DELETE_MESSAGE_CONFIRM: 'Σίγουρα θέλετε να διαγράψετε αυτό το μήνυμα;',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Μπορείτε να μας δώσετε τη γνώμη σας για αυτό το προϊόν;',
    MESSAGE_DELETED: 'Αυτό το μήνυμα έχει διαγραφεί'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
